import { render, staticRenderFns } from "./GridModalSimple.vue?vue&type=template&id=a0ef11fc&scoped=true"
import script from "./GridModalSimple.vue?vue&type=script&lang=js"
export * from "./GridModalSimple.vue?vue&type=script&lang=js"
import style0 from "./GridModalSimple.vue?vue&type=style&index=0&id=a0ef11fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ef11fc",
  null
  
)

export default component.exports